// Storage keys for studio MFE PR preview functionality
export const STUDIO_MFE_OVERRIDES_KEY = 'SW_MFE_OVERRIDES';
export const STUDIO_MFE_REDIRECT_FLAG = 'REDIRECT_TO_SW';

// PR preview validation constants
export const STUDIO_MFE_VALID_HOSTNAME_SUFFIX = '.blob.core.windows.net';
export const STUDIO_MFE_VALID_PROTOCOL = 'https:';
